export default "__VITE_ASSET__41069588__"